import { externalStorefronts } from '../../configuration/storefronts.configuration'

export function isExternalStorefront(countryCode: string): boolean {
  const upperCode = countryCode.toUpperCase()
  return externalStorefronts.some(storefront =>
    storefront.storefrontCode.toUpperCase() === upperCode,
  )
}

export function getExternalStorefrontUrl(countryCode: string): string | null {
  const upperCode = countryCode.toUpperCase()
  const storefront = externalStorefronts.find(
    sf => sf.storefrontCode.toUpperCase() === upperCode,
  )

  return storefront ? storefront.externalRedirect : null
}

export function getExternalStorefrontHreflang(countryCode: string): string | null {
  const upperCode = countryCode.toUpperCase()
  const storefront = externalStorefronts.find(
    sf => sf.storefrontCode.toUpperCase() === upperCode,
  )

  return storefront ? `${storefront.language}-${storefront.storefrontCode.toLowerCase()}` : null
}
